import { ClientAccount } from '@lune-climate/lune/esm/models/ClientAccount'
import { IconButtonDropdownNew } from '@lune-fe/lune-ui-lib'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import Co2OutlinedIcon from '@mui/icons-material/Co2Outlined'
import EqualizerOutlinedIcon from '@mui/icons-material/EqualizerOutlined'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Divider from 'components/Divider'

const ClientAccountsContextMenu: FC<{
    account: ClientAccount
}> = ({ account }) => {
    const navigate = useNavigate()
    const [open, setOpen] = useState<boolean>(false)
    const calculationsWithAccountIdFilter = `/calculate-emissions?account_id=${account.id}`
    const ordersWithAccountIdFilter = `/orders?account_id=${account.id}`
    const analyticsWithAccountIdFilter = `/analytics?account_id=${account.id}`

    return (
        <IconButtonDropdownNew
            className={'context-menu'}
            sx={{ ...(open && { opacity: '1 !important' }) }}
            onToggle={(isOpen) => setOpen(isOpen)}
            icon={<MoreVertOutlinedIcon />}
        >
            <IconButtonDropdownNew.MenuItem
                icon={<Co2OutlinedIcon />}
                title={`View emissions`}
                onClick={() => navigate(calculationsWithAccountIdFilter)}
            />
            <IconButtonDropdownNew.MenuItem
                icon={<EqualizerOutlinedIcon />}
                title={`View analytics`}
                onClick={() => navigate(analyticsWithAccountIdFilter)}
            />
            <IconButtonDropdownNew.MenuItem
                icon={<CloudDownloadOutlinedIcon />}
                title={`View offset orders`}
                onClick={() => navigate(ordersWithAccountIdFilter)}
            />
            <Divider />
            <IconButtonDropdownNew.MenuItem
                icon={<ModeEditOutlineOutlinedIcon />}
                title={`Account details`}
                onClick={() => navigate(`/client-accounts/${account.id}`)}
            />
        </IconButtonDropdownNew>
    )
}

export default ClientAccountsContextMenu
